import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import { UpdateTeamInput, UpdateTeamOutput, WebAppRoutes } from "types/web-app";

export const updatePokeTeam = async (
  accessToken: string,
  input: UpdateTeamInput,
) => {
  try {
    const response = await fetchWithAuth(
      "/" + WebAppRoutes.UPDATE_POKE_TEAM,
      accessToken,
      {
        method: "POST",
        body: JSON.stringify(input),
      },
    );

    return (await response.json()) as ServiceResponse<UpdateTeamOutput>;
  } catch (error) {
    console.error(error);

    throw error;
  }
};
